module.exports = __webpack_public_path__ + "media/images/riders/small/KADE_EDWARDS-9e68494ffe3d0d22e519eb2232876d08.png";